// selectors.js
import { createSelector } from 'reselect';

const getStkOrderManualnos = (state) => state.PackingDatalist.orderManual;
export const selectStkOrderManualnos = createSelector(
    [getStkOrderManualnos],
    (ordMan) => ordMan || { data: [] }
);

const getStkOnlyManualnos = (state) => state.PackingDatalist.onlyManual;
export const selectStkOnlyManualnos = createSelector(
    [getStkOnlyManualnos],
    (onlyMan) => onlyMan || { data: [] }
);

const getStkSingleRecord = (state) => state.PackingDatalist.singleStk;
export const selectStkSingleRecord = createSelector(
    [getStkSingleRecord],
    (singleStk) => singleStk || { data: [] }
);

const getPackingSlipMemo = (state) => state.PackingDatalist.packMemo;
export const selectPackingSlipMemo = createSelector(
    [getPackingSlipMemo],
    (packMemo) => packMemo || { data: [] }
);

const getPackingData = (state) => state.PackingDatalist.pkdata;
export const selectPackingData = createSelector(
    [getPackingData],
    (pkdata) => pkdata || { data: [] }
);

const getInvoiceMemo = (state) => state.InvoiceDatalist.invMemo;
export const selectInvMemo = createSelector(
    [getInvoiceMemo],
    (invMemo) => invMemo || { data: [] }
);

const getInvoiceReg = (state) => state.InvoiceDatalist.invReg;
export const selectInvoiceReg = createSelector(
    [getInvoiceReg],
    (invReg) => invReg || { data: [] }
);

const getSaleInvoieDetails = (state) => state.PackingDatalist.saleInv;
export const selectSaleInvoiceReg = createSelector(
    [getSaleInvoieDetails],
    (saleinv) => saleinv || { data: [] }
);
const getDCDetails = (state) => state.PackingDatalist.dcInv;
export const selectDCReg = createSelector(
    [getDCDetails],
    (dcinv) => dcinv || { data: [] }
);

const getShiftingData = (state) => state.PackingDatalist.shiftdata;
export const selectShiftingData = createSelector(
    [getShiftingData],
    (shiftdata) => shiftdata || { data: [] }
);